import { useState, useCallback, useEffect } from 'react';
import './App.css';

const orderLink = "https://www.doordash.com/store/donairo's-abbotsford-29607702/37207983/?srsltid=AfmBOoqyEzYRA45Xa4yL8pOC0-86S9E5KrNyFcSDbxyU5ouIWjYjmbgh";
const skipLink = 'https://www.skipthedishes.com/donairos-south-fraser-way?utm_source=google&utm_medium=cpc&utm_campaign=CM_S_G_CAN_EN_[RES]_[ENGM]_FDSA_National&utm_campaignid=15293941365&adj_tracker=o6dvmeq&adj_campaign=15293941365&gad_source=1&gad_campaignid=15293941365&gbraid=0AAAAAD3ULIVHx13d6pikSlEbZvyqoiWty&gclid=CjwKCAjw1N7NBhAoEiwAcPchp0KrGx2kf0K0ZsIwiQtoT9dwZTYazBY6vio8qrn9ssCXGRhnHDPKexoCfZcQAvD_BwE';
const uberLink = 'https://www.ubereats.com/ca/store/donairos/GwtIWWcxWxyDiT50npSkDQ?srsltid=AfmBOoqs9ehqW4guLfE4iw1zCEUT13yfOBA1jeBAilY9QGPdk-Ij-Pv5';

const menuItems = [
  {
    name: 'Beef Donair',
    description: 'Lettuce, onion, tomato, cucumber, tzatziki, garlic sauce, hot sauce and feta cheese wrapped in fresh pita.',
    price: '$15.99',
    tag: 'Fan Favorite',
    image: '/menu-items/beef-donair.png',
  },
  {
    name: 'Deluxe Donair',
    description: 'Beef and lamb donair with our signature toppings and freshly baked pita.',
    price: '$15.99',
    tag: 'Rich & Savory',
    image: '/menu-items/deluxe-donair.png',
  },
  {
    name: 'Meat Lover Donair',
    description: 'Chicken, lamb and beef with lettuce, onion, tomato, cucumber, tzatziki, garlic sauce, hot sauce and feta cheese.',
    price: '$15.99',
    tag: 'Hearty',
    image: '/menu-items/meat-lover-donair.png',
  },
  {
    name: 'Halifax Donair',
    description: 'Beef, tomatoes, onions and sweet sauce—East Coast style.',
    price: '$15.99',
    tag: 'East Coast',
    image: '/menu-items/halifax-donair.png',
  },
  {
    name: 'Gormah Donair',
    description: 'Chicken and falafel with lettuce, onion, tomato, cucumber, tzatziki, garlic sauce, hot sauce, feta cheese in fresh pita.',
    price: '$15.99',
    tag: 'Chicken & Falafel',
    image: '/menu-items/gormah-donair.png',
  },
  {
    name: 'Chicken Shawarma',
    description: 'Chicken and rice platter with salad (lettuce, tomato, cucumber), hot sauce, tzatziki, garlic, hummus and freshly baked pita.',
    price: '$19.99',
    tag: 'Platter',
    image: '/menu-items/chicken-shawarma.png',
  },
  {
    name: 'Lamb Shawarma',
    description: 'Lamb and rice platter with salad (lettuce, tomato, cucumber), hot sauce, tzatziki, garlic, hummus and freshly baked pita.',
    price: '$19.99',
    tag: 'Platter',
    image: '/menu-items/lamb-shawarma.png',
  },
  {
    name: 'Meat Lover Shawarma',
    description: 'Chicken, lamb and beef shawarma with rice and all the fixings.',
    price: '$19.99',
    tag: 'Hearty',
    image: '/menu-items/meat-lover-shawarma.png',
  },
];

const dailyDeals = [
  { day: 'Monday', name: 'Beef Donair', image: '/menu-items/beef-donair.png' },
  { day: 'Tuesday', name: 'Deluxe Donair', image: '/menu-items/deluxe-donair.png' },
  { day: 'Wednesday', name: 'Lamb Donair', image: '/menu-items/lamb-donair.png' },
  { day: 'Thursday', name: 'Halifax Donair', image: '/menu-items/halifax-donair.png' },
  { day: 'Friday', name: 'Chicken Donair', image: '/menu-items/chicken-donair.png' },
  { day: 'Saturday', name: 'Classic Donair', image: '/menu-items/classic-donair.png' },
];

const highlights = [
  { title: 'Freshly Baked Pita', copy: 'Every donair and shawarma is wrapped in warm, freshly baked pita.' },
  { title: 'House Sauces', copy: 'Tzatziki, garlic, hot sauce—made in-house for that authentic taste.' },
  { title: 'Quality Meats', copy: 'Chicken, beef, and lamb prepared fresh and seasoned to perfection.' },
  { title: 'Abbotsford Favourite', copy: 'Locally loved donairs and shawarmas, made with care.' },
];

const address = '32833 South Fraser Way #104, Abbotsford, BC V2S 2A6';
const mapLink = 'https://www.google.com/maps?q=32833+South+Fraser+Way+%23104,+Abbotsford,+BC+V2S+2A6&output=embed';

function App() {
  const [orderModalOpen, setOrderModalOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const openOrderModal = useCallback((e) => {
    e?.preventDefault();
    setOrderModalOpen(true);
  }, []);

  const closeOrderModal = useCallback(() => {
    setOrderModalOpen(false);
  }, []);

  useEffect(() => {
    if (orderModalOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [orderModalOpen]);

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') closeOrderModal();
    };
    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [closeOrderModal]);

  const scrollToTop = (e) => {
    e?.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const closeMobileMenu = useCallback(() => setMobileMenuOpen(false), []);

  const todayIndex = new Date().getDay() - 1;
  const [dealSlide, setDealSlide] = useState(todayIndex >= 0 && todayIndex < dailyDeals.length ? todayIndex : 0);

  const prevDeal = useCallback(() => {
    setDealSlide((i) => (i - 1 + dailyDeals.length) % dailyDeals.length);
  }, []);

  const nextDeal = useCallback(() => {
    setDealSlide((i) => (i + 1) % dailyDeals.length);
  }, []);

  return (
    <>
      <header id="hero" className="hero">
        <nav className="nav">
          <a className="brand" href="#hero" onClick={scrollToTop}>
            <img src="/logo/donairos-logo.svg" alt="Donairo's logo" />
          </a>
          <div className="nav-actions">
            <a className="ghost-btn" href="#menu">Menu</a>
            <a className="ghost-btn" href="#catering">Catering</a>
            <a className="ghost-btn" href="#visit">Location</a>
            <a className="solid-btn order-trigger" href="#order" onClick={openOrderModal}><span className="order-text-desktop">Order now</span><span className="order-text-mobile">Order</span></a>
          </div>
          <button
            type="button"
            className="nav-hamburger"
            aria-label={mobileMenuOpen ? 'Close menu' : 'Open menu'}
            aria-expanded={mobileMenuOpen}
            onClick={() => setMobileMenuOpen((open) => !open)}
          >
            <span className="nav-hamburger__line" />
            <span className="nav-hamburger__line" />
            <span className="nav-hamburger__line" />
          </button>
          {mobileMenuOpen && <div className="nav-overlay" aria-hidden onClick={closeMobileMenu} />}
          <div className={`nav-dropdown ${mobileMenuOpen ? 'nav-dropdown--open' : ''}`}>
            <a className="nav-dropdown__link" href="#menu" onClick={closeMobileMenu}>Menu</a>
            <a className="nav-dropdown__link" href="#catering" onClick={closeMobileMenu}>Catering</a>
            <a className="nav-dropdown__link" href="#visit" onClick={closeMobileMenu}>Location</a>
            <a className="nav-dropdown__link nav-dropdown__link--order order-trigger" href="#order" onClick={(e) => { closeMobileMenu(); openOrderModal(e); }}><span className="order-text-desktop">Order now</span><span className="order-text-mobile">Order</span></a>
          </div>
        </nav>
        <div className="deal-carousel" aria-label="Daily deal">
          <div className="deal-carousel__eyebrow">Daily Deal · $9.99</div>
          <div className="deal-carousel__viewport">
            <button
              type="button"
              className="deal-carousel__arrow deal-carousel__arrow--prev"
              aria-label="Previous day"
              onClick={prevDeal}
            >
              ‹
            </button>
            <div className="deal-carousel__track" style={{ transform: `translateX(-${dealSlide * 100}%)` }}>
              {dailyDeals.map((deal, i) => (
                <div className="deal-slide" key={deal.day} aria-hidden={i !== dealSlide}>
                  <img src={deal.image} alt={deal.name} loading={i === dealSlide ? 'eager' : 'lazy'} />
                  <div className="deal-slide__info">
                    <span className="deal-slide__day">
                      {deal.day}
                      {i === todayIndex && <span className="deal-slide__today"> · Today</span>}
                    </span>
                    <strong className="deal-slide__name">{deal.name}</strong>
                    <span className="deal-slide__price">$9.99</span>
                  </div>
                </div>
              ))}
            </div>
            <button
              type="button"
              className="deal-carousel__arrow deal-carousel__arrow--next"
              aria-label="Next day"
              onClick={nextDeal}
            >
              ›
            </button>
          </div>
          <div className="deal-carousel__dots">
            {dailyDeals.map((deal, i) => (
              <button
                key={deal.day}
                type="button"
                className={`deal-carousel__dot ${i === dealSlide ? 'deal-carousel__dot--active' : ''}`}
                aria-label={`Go to ${deal.day}'s deal`}
                onClick={() => setDealSlide(i)}
              />
            ))}
          </div>
        </div>
        <div className="hero-grid">
          <div className="hero-copy">
            <p className="eyebrow">Abbotsford · Donairs & Shawarmas</p>
            <h1>Fresh donairs, shawarmas, and real flavour.</h1>
            <p className="lede">
              Wrapped in freshly baked pita with tzatziki, garlic sauce, and all the fixings.
              From classic beef and chicken to Halifax-style and platters—we've got the bite you crave.
            </p>
            <div className="hero-cta">
              <a className="solid-btn order-trigger" href="#order" onClick={openOrderModal}>Order for pickup or delivery</a>
              <a className="ghost-btn" href="#menu">Browse the menu</a>
            </div>
            <div className="hero-pills hero-pills-desktop">
              {highlights.map((item) => (
                <div key={item.title} className="pill">
                  <h4>{item.title}</h4>
                  <p>{item.copy}</p>
                </div>
              ))}
            </div>
          </div>
          <div className="hero-image">
            <img src="/logo/cover.jpg" alt="Donairo's donair" />
            <div className="floating-card">
              <p>Fan favourite</p>
              <strong>Chicken Donair</strong>
              <span>Fresh pita · Tzatziki · House sauces</span>
            </div>
          </div>
          <div className="hero-pills hero-pills-row">
            {highlights.map((item) => (
              <div key={item.title} className="pill">
                <h4>{item.title}</h4>
                <p>{item.copy}</p>
              </div>
            ))}
          </div>
        </div>
      </header>

      <main>
        <section className="note-section" id="catering">
          <div className="catering-card">
            <div className="catering-card__image">
              <img src="/logo/donair-catering.png" alt="Donairo's catering tray with donairs, shawarmas, salads and sides" />
            </div>
            <div className="catering-card__content">
              <p className="eyebrow">Catering</p>
              <h3>We cater to events</h3>
              <p className="lede">
                From office lunches to parties and special occasions—Donairo's brings fresh donairs,
                shawarmas, and house sauces to your event. Contact us to plan your order.
              </p>
              <a className="solid-btn" href="tel:+16047764471">Contact</a>
            </div>
          </div>
        </section>

        <section id="menu" className="menu-section">
          <header className="menu-section-header">
            <p className="menu-section-header__eyebrow">Menu highlights</p>
            <h2 className="menu-section-header__title">Donairs <span className="menu-section-header__divider">·</span> Shawarmas</h2>
            <p className="menu-section-header__lede">Wrapped in fresh pita with house sauces—classic, deluxe, or loaded.</p>
          </header>
          <div className="menu-grid">
            {menuItems.map((item) => (
              <article key={item.name} className="menu-card">
                <div className="menu-image-wrap">
                  <img src={item.image} alt={item.name} loading="lazy" />
                  <span className="menu-tag">{item.tag}</span>
                </div>
                <div className="menu-body">
                  <div className="menu-header">
                    <h3>{item.name}</h3>
                  </div>
                  <p>{item.description}</p>
                  <a className="ghost-btn order-trigger" href="#order" onClick={openOrderModal}><span className="order-text-desktop">Order now</span><span className="order-text-mobile">Order</span></a>
                </div>
              </article>
            ))}
          </div>
          <nav className="menu-categories" aria-label="Menu categories">
            <div className="menu-category-item">
              <img src="/logo/chicken.svg" alt="" aria-hidden />
              <span>Chicken</span>
            </div>
            <div className="menu-category-item">
              <img src="/logo/beef.svg" alt="" aria-hidden />
              <span>Beef</span>
            </div>
            <div className="menu-category-item">
              <img src="/logo/lamb.svg" alt="" aria-hidden />
              <span>Lamb</span>
            </div>
            <div className="menu-category-item">
              <img src="/logo/vegan.svg" alt="" aria-hidden />
              <span>Vegan</span>
            </div>
          </nav>
        </section>

        <section id="visit" className="order-visit-section">
          <div className="order-visit-card">
            <div className="order-visit-content">
              <div className="order-visit-block location-info">
                <p className="eyebrow">Visit or call</p>
                <h3>Find Donairo's</h3>
                <p className="muted">{address}</p>
                <div className="hours">
                  <div>
                    <strong>Hours</strong>
                    <ul>
                      <li>Mon–Sat: 11:00 a.m. – 9:00 p.m.</li>
                      <li>Sun: Closed</li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="order-visit-block">
                <p className="eyebrow">Ready when you are</p>
                <h3>Order tonight.</h3>
                <p className="muted">Pickup or get it delivered—DoorDash, Skip, or Uber Eats.</p>
                <div className="cta-actions">
                  <a className="solid-btn order-trigger" href="#order" onClick={openOrderModal}>Choose your delivery app</a>
                  <a className="ghost-btn" href="tel:+16047764471">Call the kitchen</a>
                </div>
              </div>
            </div>
            <div className="map-wrap">
              <iframe
                title="Donairo's on Google Maps"
                src={mapLink}
                loading="lazy"
                allowFullScreen
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </div>
        </section>
      </main>

      <footer className="footer">
        <div className="footer-grid">
          <div className="brand inline">
            <img src="/logo/donairos-logo.svg" alt="Donairo's logo" />
          </div>
          <p className="footer-muted">Abbotsford, BC · Fresh donairs & shawarmas. ©2024 Donairos.</p>
          <div className="footer-links">
            <a className="order-trigger" href="#order" onClick={openOrderModal}>Order</a>
            <a href="#menu">Menu</a>
            <a href="#visit">Location</a>
          </div>
        </div>
      </footer>

      <div
        className={`order-modal ${orderModalOpen ? 'open' : ''}`}
        id="order-modal"
        aria-hidden={!orderModalOpen}
        role="dialog"
        aria-label="Choose ordering app"
      >
        <div className="order-modal__backdrop" onClick={closeOrderModal} aria-hidden="true" />
        <div className="order-modal__dialog" onClick={(e) => e.stopPropagation()}>
          <button className="order-modal__close" type="button" aria-label="Close" onClick={closeOrderModal}>×</button>
          <div className="modal-brand">
            <img src="/logo/donairos-logo.svg" alt="Donairo's logo" />
          </div>
          <p className="eyebrow">Order online</p>
          <h3>Choose your app</h3>
          <p className="muted">Pick the platform you prefer to get your Donairo's fix.</p>
          <div className="order-modal__grid">
            <a className="order-option doordash" href={orderLink} target="_blank" rel="noreferrer">
              <span>DoorDash</span>
              <small>Pickup or delivery</small>
            </a>
            <a className="order-option skip" href={skipLink} target="_blank" rel="noreferrer">
              <span>SkipTheDishes</span>
              <small>Pickup or delivery</small>
            </a>
            <a className="order-option uber" href={uberLink} target="_blank" rel="noreferrer">
              <span>Uber Eats</span>
              <small>Pickup or delivery</small>
            </a>
            <a className="order-option call" href="tel:+16047764471">
              <span>Call the kitchen</span>
              <small>Talk to us directly</small>
            </a>
          </div>
        </div>
      </div>
    </>
  );
}

export default App;
